/*
 * @Date: 2020-08-31 14:09:19
 * @Author: MX
 * @LastEditTime: 2020-08-31 19:48:42
 * @Description: vuex
 */
import * as Types from "../mutation-types";
import { bus,changeLang } from '@utils/common'
import {DEFAULT_LANG,LANG_ELEMENT_MAP} from '@constants/index'
// 获取本地国际化json
const lang = localStorage.getItem('lang') || DEFAULT_LANG
const langJsonStr = localStorage.getItem(`langJson`) || ''
const langJson = langJsonStr && JSON.parse(langJsonStr) || {}

changeLang(LANG_ELEMENT_MAP[lang] || lang)

const base = {
  state: {
    user: JSON.parse(localStorage.getItem("userData")) || null, // 用户信息
    token: localStorage.getItem("YL_TOKEN") || "",
    uuid: localStorage.getItem("uuid") || "",
    lang, // 国际化配置
    langJson,
    langList: JSON.parse(localStorage.getItem('langList') || '[]'), // 国家语言列表,

  },
  mutations: {
    // 用户信息
    [Types.SET_USER]: (state, data) => {
      state.user = data;
      localStorage.setItem("userData", JSON.stringify(data));
    },
    // 用户token
    [Types.SET_TOKEN]: (state, data) => {
      state.token = data;
      localStorage.setItem("YL_TOKEN", data);
    },
    // 用户uuid
    [Types.SET_UUID]: (state, data) => {
      state.uuid = data;
      localStorage.setItem("uuid", data);
    },
    // 退出
    [Types.LOGIN_OUT]: (state) => {
      // 退出登录，清楚本地缓存
      localStorage.removeItem("userData");
      localStorage.removeItem("YL_TOKEN");
      localStorage.removeItem("uuid");
      state.token = "";
      state.user = {};
      state.uuid = "";
    },
    // 国际化
    // 本地langjson 数据
    SET_LANG_JSON: (state, data = {}) => {
      state.langJson = data
      localStorage.setItem('langJson', JSON.stringify(data))
      bus.$emit('langJsonChange', data)
    },
    // 设置国家语言列表
    SET_LANG_LIST: (state, data) => {
      state.langList = data
      localStorage.setItem('langList', JSON.stringify(data))
    },
    // 本地lang
    SET_DEFAULT_LANG: (state, data = {}) => {
      state.lang = data
      localStorage.setItem('lang', data)
    },
    // 设置国际化
    SET_LANG: (state, data) => {
      if (data !== state.lang) {
        localStorage.setItem('lang', data)
        state.lang = data
        // location.reload()
      }
    },
  },
  actions: {
    // 登录初始化
    [Types.LOGIN_INIT]({ commit } = {}, value) {
      const { user, token } = value;
      commit("SET_USER", user);
      commit("SET_TOKEN", token);
    },
    // 退出
    [Types.LOGIN_OUT]({ commit } = {}) {
      commit("LOGIN_OUT");
    },
    // uuid
    [Types.SET_UUID]({ commit } = {}, value) {
      commit("SET_UUID", value);
    },
    // 国际化
    SET_LANG_JSON({ commit }, value) {
      commit('SET_LANG_JSON', value)
    },
    SET_DEFAULT_LANG({ commit }, value) {
      commit('SET_DEFAULT_LANG', value)
    },
    SET_LANG_LIST({ commit }, value) {
      commit('SET_LANG_LIST', value)
    },
    SET_LANG({ commit }, value) {
      commit('SET_LANG', value)
    },
  },
  getters: {
    user: (state) => state.user,
    token: (state) => state.token || "",
    uuid: (state) => state.uuid || "",
    lang: state => state.lang,
    langList: state => state.langList,
  },
};
export default base;
